let test_modules = {
	pre_conditionsKeys : [
        "Pre_Interview_2",
        "Pre_Interview_3",
        "Pre_Interview_4",
        "Pre_Interview_5",
        "Pre_Interview_6",
        "Pre_Interview_7",
        "Pre_Interview_8",
        "Pre_Interview_9",
        "Pre_Interview_10",
        "Pre_Interview_11"
	]
};

export default test_modules;



//////////////////
// WEBPACK FOOTER
// ./~/test_modules/test_modules.js
// module id = ./node_modules/test_modules/test_modules.js
// module chunks = 1